module.exports = __webpack_public_path__ + "images/img-KiTyayh.jpg";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/dashboard/year-results/en/growth.jpg
// module id = 1993
// module chunks = 0